import { useMutation } from '@tanstack/react-query';

import type { JsonDataItem } from 'types';
import { parseErrors, Toast } from 'helpers';
import { putTaskSendEmail } from 'queries';

function useSendEmail(onSuccess?: () => void) {
  const { mutate: sendEmail, isLoading: isSending } = useMutation(putTaskSendEmail, {
    onSuccess,
    onError: (error: JsonDataItem) => {
      Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
    },
  });

  return { sendEmail, isSending };
}

export { useSendEmail };
